(() => {
  const roots = new WeakSet();
  const start = (scope = document) => {
    scope.querySelectorAll('[data-og-reading-tables]').forEach((root) => {
      if (roots.has(root)) return;
      roots.add(root);
      const tracked = new WeakSet();
      const update = (scroller) => {
        const overflow = scroller.scrollWidth > scroller.clientWidth + 1;
        if (overflow) {
          scroller.setAttribute('tabindex', '0');
          scroller.setAttribute('role', 'region');
          scroller.setAttribute('aria-label', scroller.dataset.ogTableName);
        } else {
          scroller.removeAttribute('tabindex');
          scroller.removeAttribute('role');
          scroller.removeAttribute('aria-label');
        }
      };
      const resize = 'ResizeObserver' in window ? new ResizeObserver((entries) => {
        entries.forEach(({target}) => update(target.matches('.table-scroller') ? target : target.parentElement));
      }) : null;
      const scan = () => {
        root.querySelectorAll('.table-scroller').forEach((scroller) => {
          if (tracked.has(scroller) || scroller.hasAttribute('role') || scroller.hasAttribute('tabindex') || scroller.hasAttribute('aria-label') || scroller.hasAttribute('aria-labelledby')) return;
          const table = scroller.querySelector('table');
          if (!table) return;
          let heading = document.querySelector('main h1');
          for (const candidate of root.querySelectorAll('h2,h3,h4')) {
            if (candidate.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING) heading = candidate;
          }
          const name = table.caption?.textContent.trim() || heading?.textContent.trim();
          if (!name) return;
          const columns = [...table.querySelectorAll('thead th')].map((cell) => cell.textContent.trim()).filter(Boolean).join(' · ');
          scroller.dataset.ogTableName = [name, columns].filter(Boolean).join(' · ');
          tracked.add(scroller);
          update(scroller);
          resize?.observe(scroller);
          resize?.observe(table);
        });
      };
      new MutationObserver(scan).observe(root, {childList: true, subtree: true});
      if (!resize) window.addEventListener('resize', () => root.querySelectorAll('[data-og-table-name]').forEach(update), {passive: true});
      scan();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once: true});
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
